/** Public identity stays with the page; controls share the governed focus and density. */
export const PUBLIC_FOCUS = "focus-visible:rounded-control focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export const PUBLIC_LINK = `inline-flex min-h-[var(--control-height-compact)] items-center underline-offset-4 transition-colors duration-[var(--motion-fast)] ease-[var(--ease-standard)] ${PUBLIC_FOCUS}`;
